import { PaymentMethodCode } from "@omni/types/components/payment/shared/enum/paymentMethodCode.enum";
import { ReactElement } from "react";

import { CreditCardPayment } from "@/components/Checkout/Payment/paymentMethods/paymentMethod/creditCardPayment/creditCardPayment.component";

type Config = {
    componentMap: Partial<Record<PaymentMethodCode, ReactElement>>;
    nonPreSelectable: Array<PaymentMethodCode>;
    giftCard: Array<PaymentMethodCode>;
    tokenizable: Array<PaymentMethodCode>;
    sorting: Array<PaymentMethodCode>;
};

export const PaymentMethodsConfig: Config = {
    componentMap: {
        [PaymentMethodCode.CREDITCARD]: <CreditCardPayment />
    },
    nonPreSelectable: [PaymentMethodCode.GIFTCARD, PaymentMethodCode.COUPON],
    giftCard: [PaymentMethodCode.GIFTCARD, PaymentMethodCode.COUPON],
    tokenizable: [PaymentMethodCode.CREDITCARD],
    sorting: [
        PaymentMethodCode.BANCONTACT,
        PaymentMethodCode.CREDITCARD,
        PaymentMethodCode.TERMINAL,
        PaymentMethodCode.VOUCHER,
        PaymentMethodCode.KLARNA,
        PaymentMethodCode.COUPON,
        PaymentMethodCode.GIFTCARD
    ]
};
